import React, {
  createContext, useContext, useEffect, useState, useMemo,
  useCallback,
} from 'react';
import {
  getAuth, onAuthStateChanged, signInWithPopup, GoogleAuthProvider,
} from 'firebase/auth';

const AuthContext = createContext();

export function AuthProvider({ app, children }) {
  const [currentUser, setCurrentUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [initializing, setInitializing] = useState(true);
  const auth = getAuth(app);
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      setCurrentUser(user);
      setInitializing(false);
    });
    return unsubscribe;
  }, [auth]);

  const signInWithGoogle = useCallback(() => {
    setLoading(true);
    const provider = new GoogleAuthProvider();
    return signInWithPopup(auth, provider).finally(() => {
      setLoading(false);
    });
  }, [auth]);

  const value = useMemo(() => ({
    currentUser,
    loading,
    initializing,
    signInWithGoogle,
  }), [currentUser, loading, initializing, signInWithGoogle]);

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
